import { defineCustomElement } from "vue";
import { Register } from "..";
import F360Button from "./F360Button.ce.vue";

const tag = "vc-button";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(F360Button));
  }
};

export default _register;
